// eslint-disable-next-line import/no-anonymous-default-export
export default (revalue = [], action) => {
  switch (action.type) {
    case "FETCH_ALL_REVALUE_ASSET":
      return action.payload;

    case "REVALUATE_ASSET":
      return [...revalue, action.payload];

    default:
      return revalue;
  }
};
